/* tslint:disable */
/* eslint-disable */
/**
 * Swagger wiegaaterkoffiehalen
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.3.5
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';

/**
 * 
 */
export class MonitoringApi extends runtime.BaseAPI {

    /**
     * Creates request options for getMetrics without sending the request
     */
    async getMetricsRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/metrics`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Prometheus scrape endpoint, protected with HTTP basic auth. Missing or invalid credentials currently result in a 500.
     * Get Prometheus metrics
     */
    async getMetricsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        const requestOptions = await this.getMetricsRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Prometheus scrape endpoint, protected with HTTP basic auth. Missing or invalid credentials currently result in a 500.
     * Get Prometheus metrics
     */
    async getMetrics(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.getMetricsRaw(initOverrides);
        return await response.value();
    }

}
